'use client';
import React from 'react';

import { ErrorBoundary } from '@benzinga/core-ui';
import classNames from 'classnames';
import styles from './SimpleHeader.module.scss';

import { NavigationHeaderProps } from '../../../../entities';
import { MenuInterface } from '../../interfaces';
import { NavigationLogo } from '../../NavigationLogo';
import { Menu } from '../../Menu';
import { PrimaryMenuWrapper } from '../../HeaderDesktop';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { SimpleSearch } from './SimpleSearch';
import { SimpleHeaderBar } from './SimpleHeaderBar';
import { useSyncStickyNavOffset } from '../../../../hooks/useSyncStickyNavOffset';

export interface NavigationMenus {
  primary: MenuInterface[];
  secondary: MenuInterface[];
}

export const SimpleHeaderDesktop = ({ hideMenuBar, logoVariant, menus, sticky }: NavigationHeaderProps) => {
  const desktopMenuWrapperRef = React.useRef<HTMLDivElement | null>(null);
  const stickyNavHeight = useSyncStickyNavOffset(desktopMenuWrapperRef, Boolean(sticky));
  const { i18n } = useTranslation();
  const currentLocale = i18n.language;
  const todayDate = DateTime.now().setLocale(currentLocale).toFormat('EEEE, MMMM dd');

  const redirectToSearch = (value: string) => {
    window.location.replace(`https://${window.location.host}/?s=${value}`);
  };

  return (
    <>
      {sticky ? (
        <div
          aria-hidden
          className={classNames('navbar-placeholder', styles.navbarPlaceholder)}
          style={{ height: stickyNavHeight }}
        />
      ) : null}
      <div
        className={classNames(styles.desktopMenuWrapper, {
          [styles.desktopMenuWrapperFixed]: sticky,
        })}
        id="navigation-header"
        ref={desktopMenuWrapperRef}
      >
        <SimpleHeaderBar />
        <div className={`${styles.mainContainer} flex flex-nowrap justify-center justify-items-center py-7 border-b`}>
          <ErrorBoundary name="benzinga-logo-wrapper">
            <NavigationLogo deviceType="desktop" logoVariant={logoVariant} />
          </ErrorBoundary>
        </div>
        <div className={styles.simpleMenuContainer}>
          <div className="text-xs flex items-center">{todayDate}</div>
          {!hideMenuBar && (
            <PrimaryMenuWrapper>
              <ul className={styles.menuItemContainer}>
                {menus?.primary?.map((menu: MenuInterface, i: number) => {
                  return (
                    <li key={i}>
                      <Menu menu={menu} />
                    </li>
                  );
                })}
              </ul>
            </PrimaryMenuWrapper>
          )}
          <div className="flex justify-end items-center">
            <SimpleSearch onSearch={redirectToSearch} />
          </div>
        </div>
      </div>
    </>
  );
};
